import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { getDefaultFormState } from "react-jsonschema-form/lib/utils";
import { Utils } from "react-jsonschemapath-form";
import update from "immutability-helper";
import { StepperComp as Stepper, StepComp as Step, ReviewComp as Review } from "react-jsonschemapath-form";
import SweetAlert from "react-bootstrap-sweetalert";
import {
  Loading,
  NavigationPrompt,
  IntlFieldTemplateComp as IntlFieldTemplate,
  customWidgetsComp as customWidgets,
} from "qjumpers.common.ui";
import Immutable from "immutable";
import deepmerge from "deepmerge";
import objectPath from "object-path";
import { candidateId as candidateIdRecoil, currentCandidateData } from "../../../recoil/candidate/atom";
import { jobStatusData } from "../../../recoil/jobStatus/atom";
import { jobTypesData } from "../../../recoil/jobTypes/atom";
import { occupationsData } from "../../../recoil/occupations/atom";
import { createEnumItemsDefinition, updateApplicationInternalUiSchema } from "../utils";
import { customFields } from "../../../FormComponents/Fields";
import schemaJson from "./schema.json";
import uiSchema1Json from "./uiSchema/1.json";
import uiSchema2Json from "./uiSchema/2.json";
import uiSchema3Json from "./uiSchema/3.json";
import uiSchema4Json from "./uiSchema/4.json";
import uiSchema5Json from "./uiSchema/5.json";
import emptyQuestionnaireSchemaJson from "./uiSchema/EmptyQuestionnaire.json";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { cloneDeep } from "lodash";
import { errorState } from "../../../recoil/error/atom";
import {
  addApplication,
  getApplicationByJob,
  loadCandidateProfile,
  saveConfidentialQuestionnaireAnswers,
} from "../../../requests/applications";
import {
  getJobUrlIdentifier,
  loadConfidentialQuestionnaire,
  loadConfidentialQuestionnaireAcceptanceStage,
  loadJob,
} from "../../../requests/jobs";
import { handleOAuthRedirect } from "../../../requests/users";
import { toastMessageState } from "../../../recoil/toast/atom";
import {
  overridePopulateDataFromProfile,
  setCountryValidation,
  prePopulateDataFromCandidate,
  getLastMandatoryStep,
  setParsedAddress,
  checkJobExpiredAndApplicationAllowed,
  setCvAndCoverletterRequiredOrOptional,
  highlightRequiredQuestions,
} from "./applicationHelpers";
import { Alert, Button, Modal } from "react-bootstrap";
import { addDraftApplication, getExistingApplication, saveDraftApplication } from "../../../requests/applicationDrafts";
import { cvParsingResponse } from "../../../recoil/cvparsing/atom";

const ApplicationForm = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const popError = useSetRecoilState(errorState);
  const popToast = useSetRecoilState(toastMessageState);
  const candidateId = useRecoilValue(candidateIdRecoil);
  const getCvParsingResponseData = useRecoilValue(cvParsingResponse);

  const jobTypes = useRecoilValue(jobTypesData);
  const jobStatuses = useRecoilValue(jobStatusData);
  const occupations = useRecoilValue(occupationsData);
  const candidate = useRecoilValue(currentCandidateData);

  const params = useParams();
  const location = useLocation();
  const urlQueries = new URLSearchParams(location.search);

  const [formData, setFormData] = useState({});
  const [schema, setSchema] = useState(schemaJson);
  const [jobInvitationId, setJobInvitationId] = useState(urlQueries.get("jobinvitationid") || "");
  const [applicantSource, setApplicantSource] = useState(urlQueries.get("source") || "");
  const [confidentialQuestionnaireUiSchema, setConfidentialQuestionnaireUiSchema] = useState();
  const [confidentialQuestionnaireId, setConfidentialQuestionnaireId] = useState();
  const [submitConfidentialInfo, setSubmitConfidentialInfo] = useState(false);
  const [init, setInit] = useState(false);
  const [identifier, setIdentifier] = useState();

  const [oauthRedirectUrlForThirdPartyProvider, setOauthRedirectUrlForThirdPartyProvider] = useState();
  const [uiSchema1, setUiSchema1] = useState(uiSchema1Json);
  const [uiSchema2, setUiSchema2] = useState(uiSchema2Json);
  const [uiSchema3, setUiSchema3] = useState(uiSchema3Json);
  const [uiSchema4, setUiSchema4] = useState(uiSchema4Json);
  const [uiSchema5, setUiSchema5] = useState(uiSchema5Json);
  const [job, setJob] = useState();
  const [organisationQuestionnaireUiSchema, setOrganisationQuestionnaireUiSchema] = useState();
  const [screeningQuestionnaireUiSchema, setScreeningQuestionnaireUiSchema] = useState();
  const [pristine, setPristine] = useState(true);
  const [checksum, setChecksum] = useState(new Date().getTime());
  const [stepNavigation, setStepNavigation] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [alertTitle, setAlertTitle] = useState();
  const [alert, setAlert] = useState(false);
  const [alertError, setAlertError] = useState(false);
  const [alertMessage, setAlertMessage] = useState();

  //New State added
  const [draftDetails, setDraftDetails] = useState();
  const [navigateAway, setNavigateAway] = useState(true);
  const [initialiseCalled, setInitialiseCalled] = useState(false);

  const initialise = () => {
    const jobTypesSchema = createEnumItemsDefinition("jobTypes", jobTypes);
    const jobStatusSchema = createEnumItemsDefinition("jobStatus", jobStatuses);
    const occupationsSchema = createEnumItemsDefinition("occupations", occupations, "label");
    let newSchema = Immutable.fromJS(schemaJson)
      .set("definitions", {
        ...schemaJson.definitions,
        ...jobTypesSchema,
        ...jobStatusSchema,
        ...occupationsSchema,
      })
      .toJS();
    const formDataNew = getDefaultFormState(newSchema, formData, newSchema.definitions);
    setFormData(formDataNew);
    setSchema(newSchema);

    setInitialiseCalled(true);
  };

  useEffect(() => {
    if (jobTypes && jobStatuses && occupations && candidate) {
      initialise();
    }
  }, [jobTypes, jobStatuses, occupations, candidate]);

  const getQuestionnaireFrom = (questionnaireResponse, key) => {
    var questionnaireClone = cloneDeep(emptyQuestionnaireSchemaJson);
    questionnaireClone.content[0].content[0].key = key;
    questionnaireClone.content[0].content[0].schema["ui:options"].survey = JSON.parse(
      questionnaireResponse.model
    ).model;
    return {
      newSurveyUiSchema: questionnaireClone,
      questionnaireId: questionnaireResponse.id,
    };
  };

  const showError = (title, message, jobIdentifier) => {
    popError([
      {
        type: "warning",
        title: title,
        message: message,
        confirmBtnText: t("Action.Ok"),
        confirmBtnBsStyle: "success",
        cancelBtnBsStyle: "default",
        onConfirm: () => {
          navigateToListView(null, false, jobIdentifier);
        },
      },
    ]);
  };

  const showAlertError = (title, message) => {
    setAlertError(true);
    setAlertTitle(title);
    setAlertMessage(message);
  };

  useEffect(() => {
    const code = urlQueries.get("code");
    if (initialiseCalled) {
      setInitialiseCalled(false);
      if (params.jobId) {
        const linkWithoutLinkedin =
          typeof location.search == "string" &&
          location.search.includes("link") &&
          !location.search.includes("linkedin");

        if (linkWithoutLinkedin) {
          const candidateID = urlQueries.get("candidateID");
          let confidentialQuestionnaire = null;
          loadConfidentialQuestionnaire(params.jobId, candidateID).then((result) => {
            confidentialQuestionnaire = getQuestionnaireFrom(result.data, "confidentialQuestionnaireAnswer.model");
            setConfidentialQuestionnaireId(result.data.id);
            setConfidentialQuestionnaireUiSchema(confidentialQuestionnaire.newSurveyUiSchema);
            setSubmitConfidentialInfo(true);
            setInit(true);
          });
        } else {
          getJobUrlIdentifier(params.jobId).then((result) => {
            const jobResult = result.data;

            if (!jobResult || !jobResult.identifier) {
              showError(t("Applications.Error"), t("Error.ParsingJsonOfDraftApplication"));
            } else {
              setIdentifier(jobResult.identifier);
              getApplicationByJob(params.jobId).then((result) => {
                if (!result.data) {
                  handleOAuthRedirect(window.location.href, params.jobId).then((response) => {
                    if (response.data && response.data.url !== null) {
                      setOauthRedirectUrlForThirdPartyProvider(response.data.url);
                    }
                  });
                  loadConfidentialQuestionnaireAcceptanceStage(params.jobId).then((result) => {
                    // setConfidentialQuestionnaireAcceptanceStage(result.data.confidentialInformationAcceptanceStage);
                    const confidentialQuestStage = result.data.confidentialInformationAcceptanceStage;
                    getExistingApplication(params.jobId).then((result) => {
                      const existApplicationResult = result.data;
                      if (!result.data) {
                        let newFormData = getDefaultFormState(
                          schema,
                          { application: { jobId: params.jobId } },
                          schema.definitions
                        );
                        newFormData.source = applicantSource;
                        newFormData.jobInvitationId = jobInvitationId;
                        if (code && code !== null && code !== "") {
                          loadCandidateProfile(params.jobId, code).then((result) => {
                            const profile = result.data;
                            if (profile && profile !== null) {
                              popToast([
                                {
                                  type: "success",
                                  title: t("Application.Seek.Profile.Message"),
                                },
                              ]);
                            }
                            mountJob(params.jobId, newFormData, profile, confidentialQuestStage);
                          });
                        } else {
                          mountJob(params.jobId, newFormData, null, confidentialQuestStage);
                        }
                      } else {
                        try {
                          let newFormData = JSON.parse(existApplicationResult.draftDetails);
                          newFormData.id = existApplicationResult.id;
                          newFormData.jobId = existApplicationResult.jobId;
                          newFormData.candidateId = existApplicationResult.candidateId;

                          if (code && code !== null && code !== "") {
                            loadCandidateProfile(params.jobId, code).then((result) => {
                              const profile = result.data;
                              if (profile && profile !== null) {
                                popToast([
                                  {
                                    type: "success",
                                    title: t("Application.Seek.Profile.Message"),
                                  },
                                ]);
                              }
                              mountJob(existApplicationResult.jobId, newFormData, profile, confidentialQuestStage);
                            });
                          } else {
                            mountJob(existApplicationResult.jobId, newFormData, null, confidentialQuestStage);
                          }
                        } catch (e) {
                          showError(t("Applications.Error"), t("Error.ParsingJsonOfDraftApplication"));
                        }
                      }
                    });
                  });
                } else {
                  showError(t("Applications.Error"), t("Form.Errors.AlreadyApplied"), jobResult.identifier);
                }
              });
            }
          });
        }
      }
    }
  }, [initialiseCalled]);

  useEffect(() => {
    if (submitting && draftDetails) {
      let newFormData = {
        jobId: params.jobId ? params.jobId : draftDetails.jobId,
        candidateId: candidateId,
        draftDetails: JSON.stringify(draftDetails),
      };

      //As per existing old code we never get newFormData.id so it always go to else part and execute only saveDraft function.
      // check if we have a draft application id
      if (newFormData && newFormData.id !== "undefined" && newFormData.id !== "00000000-0000-0000-0000-000000000000") {
        // Check if an existing application exists because we have no draft id
        getExistingApplication(newFormData.jobId).then((result) => {
          if (result.data && formData) {
            newFormData.id = result.data.id;
            saveDraft(newFormData, navigateAway);
          } else {
            addDraft(newFormData, navigateAway);
          }
        });
      } else {
        // new application
        if (newFormData.id === "00000000-0000-0000-0000-000000000000") {
          addDraft(newFormData, navigateAway);
        } else {
          saveDraft(newFormData, navigateAway);
        }
      }
    }
  }, [submitting]);

  useEffect(() => {
    if (getCvParsingResponseData?.data) {
      let parsedCvResponse = cloneDeep(getCvParsingResponseData.data);
      let parsedAddress = null;
      let newProps = [];
      const keys = [
        "applicationMessage",
        "primaryContactNumber",
        "secondaryContactNumber",
        "employment",
        "qualification",
        "referee",
        "skills",
        "executiveSummary",
        "address",
      ];

      if (!parsedCvResponse?.skills) {
        parsedCvResponse["skills"] = JSON.stringify([]);
      }

      keys.forEach((key) => {
        let existing = objectPath.get(formData, key);

        if (key === "address" && parsedCvResponse.address) {
          parsedAddress = parsedCvResponse.address;
        }

        if (key === "skills" && parsedCvResponse.skills) {
          let parsedSkills = [];
          try {
            const skillsArray = JSON.parse(parsedCvResponse.skills);
            if (Array.isArray(skillsArray)) {
              // Determine if array consists of objects or strings
              if (skillsArray.length > 0 && typeof skillsArray[0] === "object") {
                parsedSkills = skillsArray.map((item) => item.tag || "");
              } else if (typeof skillsArray[0] === "string") {
                parsedSkills = skillsArray;
              }
            }
          } catch (error) {
            console.error("Error parsing skills:", error);
          }
  
          newProps.push(
            Utils.getPatch(key, existing?.length ? existing : JSON.stringify(parsedSkills))
          );
        }
        else {
          const newValue = objectPath.get(parsedCvResponse, key);
          newProps.push(Utils.getPatch(key, existing && existing.length ? existing : newValue));
        }
      });
      const newFormData = update(formData, deepmerge.all(newProps));
      newFormData.address = setParsedAddress(parsedAddress, newFormData.address);

      let schemaAndFormData = setCountryValidation(schema, newFormData);

      setSchema(schemaAndFormData.schema);
      setFormData(newFormData);
      setChecksum(new Date().getTime());
    }
  }, [getCvParsingResponseData]);

  const mountJob = (jobId, newFormData, profileData = null, confidentialQuestStage) => {
    loadJob(jobId).then((resp) => {
      const result = resp.data;
      if (!result) {
        showError(t("Applications.Error"), t("Form.Errors.ApplicationsClosed"));
      }
      checkJobExpiredAndApplicationAllowed(result, newFormData, history);
      const jobInvitationId = newFormData.jobInvitationId || "";
      newFormData.jobId = result.id;
      newFormData = prePopulateDataFromCandidate(newFormData, result, candidate);
      let organisationQuestionnaire = null;
      let screeningQuestionnaire = null;
      let confidentialQuestionnaire = null;

      if (result.screeningQuestionnaire) {
        screeningQuestionnaire = getQuestionnaireFrom(
          result.screeningQuestionnaire,
          "screeningQuestionnaireAnswer.model"
        );
        if (!newFormData.screeningQuestionnaireAnswer || !newFormData.screeningQuestionnaireAnswer.questionnaireId) {
          newFormData.screeningQuestionnaireAnswer = {
            questionnaireId: screeningQuestionnaire.questionnaireId,
          };
        }
        // screeningQuestionnaireUiSchema = screeningQuestionnaire.newSurveyUiSchema;
      }
      if (result.confidentialQuestionnaire && confidentialQuestStage == 1) {
        confidentialQuestionnaire = getQuestionnaireFrom(
          result.confidentialQuestionnaire,
          "confidentialQuestionnaireAnswer.model"
        );
        if (
          !newFormData.confidentialQuestionnaireAnswer ||
          !newFormData.confidentialQuestionnaireAnswer.questionnaireId
        ) {
          newFormData.confidentialQuestionnaireAnswer = {
            questionnaireId: confidentialQuestionnaire.questionnaireId,
          };
        }
        // confidentialQuestionnaireUiSchema = confidentialQuestionnaire.newSurveyUiSchema;
      }

      if (result.organisationQuestionnaire) {
        organisationQuestionnaire = getQuestionnaireFrom(
          result.organisationQuestionnaire,
          "organisationQuestionnaireAnswer.model"
        );
        if (
          !newFormData.organisationQuestionnaireAnswer ||
          !newFormData.organisationQuestionnaireAnswer.questionnaireId
        ) {
          newFormData.organisationQuestionnaireAnswer = {
            questionnaireId: organisationQuestionnaire.questionnaireId,
          };
        }
        // organisationQuestionnaireUiSchema = organisationQuestionnaire.newSurveyUiSchema;
      }

      updateApplicationInternalUiSchema(result.companyName, uiSchema1, t);

      let schemaAndFormData = setCountryValidation(schema, newFormData);

      if (profileData && profileData !== null && profileData !== "") {
        schemaAndFormData.formData = overridePopulateDataFromProfile(schemaAndFormData.formData, profileData);
      }

      const newSchema = setCvAndCoverletterRequiredOrOptional(result, schemaAndFormData.schema);

      setJob(result);
      setSchema(newSchema);
      if (schemaAndFormData.formData.skills && schemaAndFormData.formData.skills === '""') {
        schemaAndFormData.formData.skills = "";
      }
      setFormData(schemaAndFormData.formData);
      setScreeningQuestionnaireUiSchema(screeningQuestionnaire?.newSurveyUiSchema);
      setConfidentialQuestionnaireUiSchema(confidentialQuestionnaire?.newSurveyUiSchema);
      setOrganisationQuestionnaireUiSchema(organisationQuestionnaire?.newSurveyUiSchema);
      setJobInvitationId(jobInvitationId);

      setUiSchema1(uiSchema1);
      setUiSchema2(uiSchema2);
      setUiSchema3(uiSchema3);
      setUiSchema4(uiSchema4);
      setUiSchema5(uiSchema5);
      setInit(true);
      //form: true,
    });
  };

  const navigateToListView = (type, submitSuccess = false, jobIdentifier = null) => {
    jobIdentifier = jobIdentifier ? jobIdentifier : identifier;
    if (params.type == "add" && !submitSuccess) {
      window.location = `http://${window.location.host}/jobs/details/${jobIdentifier}/`;
    } else if (type === "drafts") {
      history.push("/applications/?type=drafts");
    } else {
      history.push("/applications");
    }
  };

  const onModalClose = () => {
    setSubmitConfidentialInfo(false);
    setInit(false);
    history.push("/applications");
  };

  const hideAlert = () => {
    setAlert(false);
  };

  const hideAlertError = () => {
    setAlertError(false);
    setAlertTitle(null);
    setAlertMessage(null);
  };

  const onFormStop = () => {
    setAlert(false);
    setAlertError(false);
    navigateToListView("", false, identifier);
  };

  const mandatoryQuestionsError = () => {
    popError([
      {
        type: "error",
        title: "Error Occured",
        message: "Fields marked with * are mandatory",
      },
    ]);
  };

  const validateDraftApplication = (formDataInput) => {
    const formDataRef = formDataInput ? formDataInput : formData;
    let invalidateArray = [];
    if (!formDataRef.firstName) {
      invalidateArray.push("firstName");
    }
    if (!formDataRef.lastName) {
      invalidateArray.push("lastName");
    }
    if (!formDataRef.email) {
      invalidateArray.push("email");
    }

    //NOt found any usage of below lines

    // let invalid = invalidateArray.length > 0;

    // this.setState({
    //   validationAlert: invalid,
    //   invalidateArray: !invalid ? null : invalidateArray
    // });
    return invalidateArray.length == 0;
  };

  const beforeSubmitAndUpdate = (update) => {
    popError([
      {
        type: "warning",
        title: t("Form.Application.Confirm.Title"),
        message: update ? t("Form.Application.SubmitAndUpdateConfirmation") : t("Form.Application.SubmitConfirmation"),
        confirmBtnText: t("Action.Submit"),
        showCancel: true,
        confirmBtnBsStyle: "success",
        cancelBtnBsStyle: "default",
        onConfirm: () => onSubmit(update),
      },
    ]);
  };

  const formPause = () => {
    setSubmitting(true);
    setChecksum(new Date().getTime());
  };

  const formPlay = (pristine = false) => {
    setSubmitting(false);
    setPristine(pristine);
    setChecksum(new Date().getTime());
  };

  const onSaveDraft = (navigateAwayInput = true) => {
    let cloneFormData = cloneDeep(formData);
    cloneFormData.source = applicantSource;
    cloneFormData.jobInvitationId = jobInvitationId;

    // DEL Empty Document
    if (cloneFormData.cv) {
      if (!cloneFormData.cv.upload) {
        delete cloneFormData.cv;
      } else if (cloneFormData.cv.base64String) {
        delete cloneFormData.cv.base64String;
      }
    }
    // DEL Empty Document
    if (cloneFormData.coverLetter) {
      if (!cloneFormData.coverLetter.upload) {
        delete cloneFormData.coverLetter;
      } else if (cloneFormData.coverLetter.base64String) {
        delete cloneFormData.coverLetter.base64String;
      }
    }
    formPause();
    setDraftDetails(cloneFormData);

    setNavigateAway(navigateAwayInput);
  };

  const addDraft = (newFormData, navigateAway) => {
    addDraftApplication(newFormData)
      .then(() => {
        if (navigateAway) {
          popToast([
            {
              type: "success",
              title: t("ApplicationDraft.Actions.Add.Success.Message"),
            },
          ]);
          navigateToListView("drafts");
        } else {
          formPlay(true);
        }
      })
      .catch(() => formPlay(true));
  };

  const saveDraft = (newFormData, navigateAwayInput = false) => {
    if (!pristine) {
      saveDraftApplication(newFormData)
        .then(() => {
          if (navigateAwayInput) {
            popToast([
              {
                type: "success",
                title: t("ApplicationDraft.Actions.Add.Success.Message"),
              },
            ]);
            setPristine(true);
            navigateToListView("drafts");
          } else {
            formPlay(true);
          }
        })
        .catch(() => formPlay(false));
    } else {
      setSubmitting(false);
      if (navigateAwayInput) {
        navigateToListView("drafts");
      }
    }
  };

  const onFormDataChange = ({ formData: formDataInput }) => {
    let updatedFormData = deepmerge.all([formData, formDataInput]);

    if (formDataInput.qualification) {
      updatedFormData.qualification = formDataInput.qualification;
    }
    if (formDataInput.referee) {
      updatedFormData.referee = formDataInput.referee;
    }
    if (formDataInput.employment) {
      updatedFormData.employment = formDataInput.employment;
    }
    if (formDataInput.candidate) {
      updatedFormData.candidate = formDataInput.candidate;
    }

    if (formDataInput.cv === null) {
      updatedFormData.cv = {
        allowCvParsing: false,
      };
    }
    // deep copy
    //let newSchema = JSON.parse(JSON.stringify(schema));

    let countryValidation = setCountryValidation(schema, updatedFormData);
    setFormData(countryValidation.formData);
    setPristine(false);
    setSchema(countryValidation.schema);
    setChecksum(new Date().getTime());
  };

  const onSubmit = (updateProfile) => {
    setDraftDetails();
    formPause();
    let cloneFormData = cloneDeep(formData);
    cloneFormData.source = applicantSource;
    cloneFormData.jobInvitationId = jobInvitationId;
    // DEL Empty Document
    if (cloneFormData.cv) {
      if (!cloneFormData.cv.upload) {
        delete cloneFormData.cv;
      } else if (cloneFormData.cv.base64String) {
        delete cloneFormData.cv.base64String;
      }
    }
    // DEL Empty Document
    if (cloneFormData.coverLetter) {
      if (!cloneFormData.coverLetter.upload) {
        delete cloneFormData.coverLetter;
      } else if (cloneFormData.coverLetter.base64String) {
        delete cloneFormData.coverLetter.base64String;
      }
    }

    if (cloneFormData.organisationQuestionnaireAnswer) {
      if (!cloneFormData.organisationQuestionnaireAnswer.questionnaireId) {
        delete cloneFormData.organisationQuestionnaireAnswer;
      }
    }

    if (cloneFormData.screeningQuestionnaireAnswer) {
      if (!cloneFormData.screeningQuestionnaireAnswer.questionnaireId) {
        delete cloneFormData.screeningQuestionnaireAnswer;
      }
    }

    if (cloneFormData.confidentialQuestionnaireAnswer) {
      if (!cloneFormData.confidentialQuestionnaireAnswer.questionnaireId) {
        delete cloneFormData.confidentialQuestionnaireAnswer;
      }
    }

    if (cloneFormData.skills === "" || cloneFormData.skills === "undefined") {
      cloneFormData.skills = JSON.stringify(cloneFormData.skills);
    }

    cloneFormData.jobId = params.jobId ? params.jobId : cloneFormData.jobId;

        if (cloneFormData.source === undefined || cloneFormData.source === null || cloneFormData.source === "") {
      const subdomain = applicantSource ? applicantSource : window.location.hostname.split('.')[0];
      var source = subdomain !== 'www' && subdomain !== 'qjumpersjobs' && subdomain !== 'qjumpers' ? subdomain : cloneFormData.source;
      cloneFormData.source = source;
    }

    addApplication(updateProfile, cloneFormData)
      .then((resp) => {
        const result = resp.data;
        if (result == null) {
          formPlay(true);
          showAlertError(
            t("Applications.Add"),
            t("application.Actions.Add.Fail.Already.Message", { email: formData.email })
          );
        } else {
          formPlay(true);
          popToast([
            {
              type: "success",
              title: t("application.Actions.Add.Success.Message"),
            },
          ]);
          navigateToListView("applied", true);
        }
      })
      .catch(() => formPlay(true));
  };

  const updateConfidentialQuestionnaireAnswers = () => {
    formData.confidentialQuestionnaireAnswer.questionnaireId = confidentialQuestionnaireId;
    saveConfidentialQuestionnaireAnswers(params.jobId, formData.confidentialQuestionnaireAnswer)
      .then(() => {
        popToast([
          {
            type: "success",
            title: t("Action.submit.questionnaire.Success.Message"),
          },
        ]);
        setSubmitConfidentialInfo(false);
        setInit(false);
        history.push("/applications");
      })
      .catch((e) => {
        onModalClose();
      });
  };

  if (!init) {
    return <Loading className="loading-component" />;
  }

  const optionalBanner = <Alert bsStyle="info">{t("Form.Application.Optional.Banner")}</Alert>;

  const allUiSchemas = [uiSchema1, uiSchema2, uiSchema3, uiSchema4, uiSchema5];
  let steps = [
    {
      name: "Form.Application.PersonalDetails",
      subName: "Form.Application.Required",
      required: true,
      showRequired: false,
      title: "Form.Application.PersonalDetails",
      icon: "qjicon-profile",
      component: (
        <Step
          schema={schema}
          uiSchema={uiSchema1}
          onUpdate={onFormDataChange}
          noValidate={false}
          fields={customFields}
          widgets={customWidgets}
          FieldTemplate={IntlFieldTemplate}
          liveValidate={true}
          formData={formData}
        />
      ),
    },
    {
      name: "Form.Application.GeneralInfo",
      subName: "Form.Application.Optional",
      required: false,
      showRequired: false,
      title: "Form.Application.GeneralInfo",
      icon: "qjicon-suitcase",
      component: (
        <Step
          schema={schema}
          uiSchema={uiSchema2}
          onUpdate={onFormDataChange}
          noValidate={false}
          fields={customFields}
          widgets={customWidgets}
          FieldTemplate={IntlFieldTemplate}
          banner={optionalBanner}
        />
      ),
    },
    {
      name: "Form.Application.Qualifications",
      subName: "Form.Application.Optional",
      required: false,
      showRequired: false,
      title: "Form.Application.Qualifications",
      icon: "qjicon-bars",
      component: (
        <Step
          schema={schema}
          uiSchema={uiSchema3}
          onUpdate={onFormDataChange}
          noValidate={true}
          fields={customFields}
          widgets={customWidgets}
          FieldTemplate={IntlFieldTemplate}
          banner={optionalBanner}
        />
      ),
    },
    {
      name: "Form.Application.Employments",
      subName: "Form.Application.Optional",
      required: false,
      showRequired: false,
      title: "Form.Application.Employments",
      icon: "qjicon-star",
      component: (
        <Step
          schema={schema}
          uiSchema={uiSchema4}
          onUpdate={onFormDataChange}
          noValidate={true}
          fields={customFields}
          widgets={customWidgets}
          FieldTemplate={IntlFieldTemplate}
          banner={optionalBanner}
        />
      ),
    },
    {
      name: "Form.Application.Preferences",
      subName: "Form.Application.Optional",
      required: false,
      showRequired: false,
      title: "Form.Application.Preferences",
      icon: "qjicon-star",
      component: (
        <Step
          schema={schema}
          uiSchema={uiSchema5}
          onUpdate={onFormDataChange}
          noValidate={true}
          fields={customFields}
          widgets={customWidgets}
          FieldTemplate={IntlFieldTemplate}
          banner={optionalBanner}
        />
      ),
    },
  ];

  steps.push({
    name: "Form.Review.Tab",
    subName: "Form.Application.Required",
    required: false,
    showRequired: false,
    title: "Form.Review.Title",
    icon: "qjicon-tick",
    component: (
      <Review
        schema={schema}
        uiSchema={allUiSchemas}
        fields={customFields}
        widgets={customWidgets}
        FieldTemplate={IntlFieldTemplate}
        validateAllSteps={true}
        liveValidate={true}
      />
    ),
  });

  if (screeningQuestionnaireUiSchema) {
    allUiSchemas.splice(1, 0, screeningQuestionnaireUiSchema);
    //make questionnaire required
    schema.properties.screeningQuestionnaireAnswer.required = ["model"];

    steps.splice(1, 0, {
      name: "Form.ScreeningQuestionnaire.Tab",
      subName: "Form.Application.Required",
      required: true,
      showRequired: true,
      title: "Form.ScreeningQuestionnaire.Title",
      icon: "qjicon-tick",
      component: (
        <Step
          schema={schema}
          uiSchema={screeningQuestionnaireUiSchema}
          noValidate={false}
          fields={customFields}
          widgets={customWidgets}
          FieldTemplate={IntlFieldTemplate}
          onUpdate={onFormDataChange}
        />
      ),
    });
  }

  if (organisationQuestionnaireUiSchema) {
    allUiSchemas.splice(1, 0, organisationQuestionnaireUiSchema);
    //make questionnaire required
    schema.properties.organisationQuestionnaireAnswer.required = ["model"];

    steps.splice(1, 0, {
      name: "Form.OrganisationQuestionnaire.Tab",
      subName: "Form.Application.Required",
      required: true,
      showRequired: true,
      title: "Form.OrganisationQuestionnaire.Title",
      icon: "qjicon-tick",
      component: (
        <Step
          schema={schema}
          uiSchema={organisationQuestionnaireUiSchema}
          noValidate={false}
          fields={customFields}
          widgets={customWidgets}
          FieldTemplate={IntlFieldTemplate}
          onUpdate={onFormDataChange}
          liveValidate={true}
        />
      ),
    });
  }

  if (confidentialQuestionnaireUiSchema && !submitConfidentialInfo) {
    allUiSchemas.splice(1, 0, confidentialQuestionnaireUiSchema);
    //make questionnaire required
    schema.properties.confidentialQuestionnaireAnswer.required = ["model"];

    steps.splice(1, 0, {
      name: "Form.ConfidentialQuestionnaire.Tab",
      subName: "Form.Application.Required",
      required: true,
      showRequired: true,
      title: "Form.ConfidentialQuestionnaire.Title",
      icon: "qjicon-tick",
      component: (
        <Step
          schema={schema}
          uiSchema={confidentialQuestionnaireUiSchema}
          noValidate={false}
          fields={customFields}
          widgets={customWidgets}
          FieldTemplate={IntlFieldTemplate}
          onUpdate={onFormDataChange}
          liveValidate={true}
        />
      ),
    });
  }

  const lastMandatoryStep = getLastMandatoryStep(steps);

  return (
    <div>
      {submitting ? (
        <div className="formLoader">
          <Loading className="loading-component" />
        </div>
      ) : null}
      {job.allowApplyWith &&
      applicantSource !== "trademe" && applicantSource !== "TradeMe" &&
      oauthRedirectUrlForThirdPartyProvider !== null &&
      oauthRedirectUrlForThirdPartyProvider !== "" ? (
        <div className="pull-right">
          <iframe
            frameBorder="0"
            width="230px"
            height="45px"
            src={"https://apply-with-seek-button.seek.com.au/white" + oauthRedirectUrlForThirdPartyProvider}
          />
        </div>
      ) : null}
      <NavigationPrompt when={!pristine} />
      <div className="job-detail">
        <div className="job-detail--header">
          <div className="row">
            <div className="col-md-8 col-xs-12">{job && <h1>{job.title}</h1>}</div>
          </div>
        </div>
        <div>
          <div>
            <div className="row">
              <div className="col-xs-12">
                <Stepper
                  checksum={checksum}
                  preventEnterSubmission={true}
                  steps={steps}
                  prevBtnOnLastStep={true}
                  dontValidate={false}
                  formData={formData}
                  alwaysUpdate={true}
                  stepsNavigation={stepNavigation}
                  reviewSteps={true}
                  pristine={pristine}
                  showErrorList={true}
                  enableStepNavigation={() => {
                    setStepNavigation(true);
                  }}
                  highlightRequiredQuestions={highlightRequiredQuestions}
                  onStepChange={() => {
                    onSaveDraft(false);
                  }}
                  jumpLastStepOn={lastMandatoryStep - 1 > 0 ? lastMandatoryStep - 1 : 0}
                  popError={() => {
                    document.getElementsByClassName(".sv_complete_btn").click();
                    popError([
                      {
                        type: "warning",
                        title: t("Form.Errors.Title"),
                        message: t("Form.Errors.PleaseCorrect"),
                        confirmBtnText: t("Action.Ok"),
                        confirmBtnBsStyle: "danger",
                        cancelBtnBsStyle: "default",
                      },
                    ]);
                  }}
                  popLastStep={(onConfirmFunc) => {
                    popError([
                      {
                        type: "info",
                        title: "",
                        message: t("Form.Optional.Message"),
                        confirmBtnBsStyle: "success",
                        confirmBtnText: t("Action.Skip"),
                        showCancel: true,
                        cancelBtnBsStyle: "success",
                        cancelBtnText: "Continue",
                        onConfirm: () => {
                          onConfirmFunc();
                        },
                      },
                    ]);
                  }}
                  actions={[
                    {
                      title: t("Action.Cancel"),
                      className: "btn btn-border btn-lg",
                      validate: false,
                      onClick: () => {
                        onFormStop();
                      },
                    },
                    {
                      title: t("Action.Draft"),
                      className: "btn btn-primary btn-lg",
                      validate: false,
                      customValidate: (data) => {
                        return validateDraftApplication(data);
                      },
                      onClick: () => {
                        onSaveDraft();
                      },
                      disabled: submitting,
                    },
                    {
                      title: t("Action.SubmitApplication"),
                      className: "btn btn-success btn-lg",
                      validate: true,
                      onClick: () => {
                        beforeSubmitAndUpdate(false);
                      },
                      disabled: submitting,
                      finalStep: true,
                    },
                    {
                      title: t("Action.SubmitAndUpdateProfile"),
                      className: "btn btn-success btn-lg",
                      validate: true,
                      onClick: () => {
                        beforeSubmitAndUpdate(true);
                      },
                      disabled: submitting,
                      finalStep: true,
                    },
                  ]}
                  mandatoryQuestionsError={mandatoryQuestionsError}
                />

                {alert ? (
                  <SweetAlert
                    warning
                    showCancel
                    confirmBtnText={t("Form.Unsaved.Leave")}
                    confirmBtnBsStyle="danger"
                    cancelBtnBsStyle="default"
                    title="Are you sure?"
                    onConfirm={onFormStop}
                    onCancel={hideAlert}>
                    {t("Form.Unsaved.Text")}
                  </SweetAlert>
                ) : null}
                {alertError ? (
                  <SweetAlert
                    warning
                    confirmBtnText={t("Modal.Close")}
                    confirmBtnBsStyle="danger"
                    cancelBtnBsStyle="default"
                    title={alertTitle}
                    onConfirm={hideAlertError}>
                    {alertMessage}
                  </SweetAlert>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={submitConfidentialInfo} onHide={onModalClose}>
        <Modal.Header closeButton className="brand-primary">
          <Modal.Title>
            <div>{t("Form.ConfidentialQuestionnaire.Title")}</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <Step
              schema={schema}
              uiSchema={confidentialQuestionnaireUiSchema}
              noValidate={false}
              fields={customFields}
              widgets={customWidgets}
              FieldTemplate={IntlFieldTemplate}
              onUpdate={onFormDataChange}
            />
          </div>
          <Button onClick={updateConfidentialQuestionnaireAnswers}>Submit</Button>
          <Button onClick={onModalClose}>Cancel</Button>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ApplicationForm;
